import { render, staticRenderFns } from "./KList.vue?vue&type=template&id=b53f552e&"
import script from "./KList.vue?vue&type=script&lang=js&"
export * from "./KList.vue?vue&type=script&lang=js&"
import style0 from "./KList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports